import React from 'react';

const CartSummary = ({ totalPrice }) => {
  const shipping = totalPrice > 100 ? 0 : 9.99;
  const tax = totalPrice * 0.08; // 8% tax
  const finalTotal = totalPrice + shipping + tax;

  return (
    <div className="space-y-2">
      <div className="flex justify-between text-sm text-gray-600">
        <span>Subtotal:</span>
        <span>${totalPrice.toFixed(2)}</span>
      </div>
      
      <div className="flex justify-between text-sm text-gray-600">
        <span>Shipping:</span>
        <span>
          {shipping === 0 ? (
            <span className="text-green-600 font-medium">FREE</span>
          ) : (
            `$${shipping.toFixed(2)}`
          )}
        </span>
      </div>
      
      <div className="flex justify-between text-sm text-gray-600">
        <span>Tax:</span>
        <span>${tax.toFixed(2)}</span>
      </div>
      
      {totalPrice > 0 && totalPrice < 100 && (
        <div className="text-xs text-blue-600 bg-blue-50 p-2 rounded-md">
          💡 Add ${(100 - totalPrice).toFixed(2)} more for free shipping!
        </div>
      )}
      
      <div className="border-t border-gray-200 pt-2">
        <div className="flex justify-between text-lg font-semibold text-gray-900">
          <span>Total:</span>
          <span>${finalTotal.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};

export default CartSummary;
